import  { ACTION_TYPES } from '../../config/constants';

export default function configs(state = { dispatch: {}}, action) {
	switch (action.type) {
		case ACTION_TYPES.GET_CONFIGS:
			let newState = Object.assign({}, action.configs);
			return newState;
        case ACTION_TYPES.SET_CONFIGS:
            let newObj = Object.assign(state, {
                [action.config.name]: action.config.value
            });
            return newObj;
		case ACTION_TYPES.GET_DISPATCHING_DATA:
			return {
				...state,
				dispatching: action.data
			};
		default:
			return state;
	}
}